import SubjectList from "./components/List";

const SubjectPage = () => {
    return (
        <SubjectList />
    )
}

export default SubjectPage;